export const ECC = Object.freeze({
    L: 'L',
    M: 'M',
    Q: 'Q',
    H: 'H',
});